import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: percorso inesistente:", location.pathname);
  }, [location.pathname]);

  return (
    <Layout>
      <div className="flex min-h-[70vh] items-center justify-center px-4 pt-20">
        <div className="text-center max-w-md">
          <p className="eyebrow">Errore 404</p>
          <h1 className="mt-3 font-serif text-6xl md:text-7xl text-primary">
            Pagina non trovata
          </h1>
          <p className="mt-4 text-foreground/75">
            La pagina che cerchi non esiste o è stata spostata.
          </p>
          <div className="mt-8 flex flex-wrap gap-4 justify-center">
            <Button asChild size="lg" className="rounded-full">
              <Link to="/">Torna alla home</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="rounded-full">
              <Link to="/trattamenti">Vedi i trattamenti</Link>
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
